/* eslint-disable react/jsx-curly-brace-presence */
import { Box, Typography } from "@mui/material";

export function MaintenanceContent() {
  return (
    <Box
      display={"flex"}
      height={"100vh"}
      color={"white"}
      sx={{
        background:
          "linear-gradient(90deg, rgba(2,0,36,1) 0%, rgba(109,40,131,1) 53%, rgba(109,40,131,1) 100%)",
      }}
    >
      <Box
        display={"flex"}
        width={"40%"}
        justifyContent={"center"}
        flexDirection={"column"}
        paddingLeft={"3rem"}
      >
        <Typography fontSize={"3rem"} marginY={"0.5rem"} fontWeight={"bold"}>
          WEBSITE UNDER MAINTENANCE
        </Typography>
        <Typography marginY={"0.5rem"}>
          Sorry for the inconvenience. We’re performing some maintenance at the
          moment.
        </Typography>
      </Box>
      <Box
        display={"flex"}
        width={"60%"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        <Box
          component={"img"}
          src={"/assets/image/maintenance.png"}
          height={"100vh"}
        />
      </Box>
    </Box>
  );
}
